"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAxiosDefaults = void 0;

var _react = require("react");

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var useAxiosDefaults = function useAxiosDefaults(_ref) {
  var auth = _ref.auth,
      baseUrl = _ref.baseUrl;
  _axios["default"].defaults.baseURL = baseUrl;
  _axios["default"].defaults.withCredentials = true;

  _axios["default"].defaults.validateStatus = function (status) {
    return status >= 200 && status < 300;
  };

  _axios["default"].defaults.xsrfCookieName = 'XSRF-TOKEN';
  _axios["default"].defaults.xsrfHeaderName = 'X-CSRF-TOKEN';
  _axios["default"].defaults.timeout = 20000;
  (0, _react.useEffect)(function () {
    _axios["default"].defaults.baseURL = baseUrl;
    _axios["default"].defaults.withCredentials = true;
  }, [auth]);
  (0, _react.useEffect)(function () {
    _axios["default"].defaults.xsrfCookieName = 'XSRF-TOKEN';
    _axios["default"].defaults.xsrfHeaderName = 'X-CSRF-TOKEN';
  }, []);
};

exports.useAxiosDefaults = useAxiosDefaults;